import { AddSpotDialog } from "../AddSpotDialog";
import { EditSpotDialog } from "../EditSpotDialog";
import { ShareDialog } from "../ShareDialog";
import { EditTripDialog } from "../EditTripDialog";
import { InviteLinkDialog } from "../InviteLinkDialog";
import { AiGenerateDialog } from "../AiGenerateDialog";
import { GroupSelectDialog } from "../trips/GroupSelectDialog";
import { QuickExpenseDialog } from "../expenses/QuickExpenseDialog";
import type { TripDetailDialogsProps } from "./types";

export function TripDetailDialogs({
  tripId,
  trip,
  dialogs,
  shareCode,
  onShare,
  onUnshare,
  isSharing,
  onAiGenerate,
  isGenerating,
  addSpotDestinationCoords,
}: TripDetailDialogsProps) {
  return (
    <>
      {/* Add Spot Dialog */}
      {dialogs.spotDialogs.addSpotItineraryId && (
        <AddSpotDialog
          tripId={tripId}
          itineraryId={dialogs.spotDialogs.addSpotItineraryId}
          open={!!dialogs.spotDialogs.addSpotItineraryId}
          onOpenChange={(open) => {
            if (!open) dialogs.setAddSpotItineraryId(null);
          }}
          destinationCoords={addSpotDestinationCoords}
          defaultStartTime={dialogs.spotDialogs.addSpotStartTime}
        />
      )}

      {/* Edit Spot Dialog */}
      {dialogs.spotDialogs.editingSpot && (
        <EditSpotDialog
          tripId={tripId}
          spot={dialogs.spotDialogs.editingSpot}
          open={!!dialogs.spotDialogs.editingSpot}
          onOpenChange={(open) => {
            if (!open) dialogs.setEditingSpot(null);
          }}
        />
      )}

      {/* Share Dialog */}
      <ShareDialog
        open={dialogs.dialogs.share}
        onOpenChange={(open) => {
          if (!open) dialogs.close("share");
        }}
        shareCode={shareCode}
        onShare={onShare}
        onUnshare={onUnshare}
        isSharing={isSharing}
      />

      {/* Edit Trip Dialog */}
      <EditTripDialog
        open={dialogs.dialogs.editTrip}
        onOpenChange={(open) => {
          if (!open) dialogs.close("editTrip");
        }}
        trip={trip}
      />

      {/* Invite Link Dialog */}
      {trip.groupId && (
        <InviteLinkDialog
          open={dialogs.dialogs.invite}
          onOpenChange={(open) => {
            if (!open) dialogs.close("invite");
          }}
          groupId={trip.groupId}
          groupName={trip.title}
        />
      )}

      {/* AI Generate Dialog */}
      <AiGenerateDialog
        open={dialogs.dialogs.aiGenerate}
        onOpenChange={(open) => {
          if (!open) dialogs.close("aiGenerate");
        }}
        onGenerate={onAiGenerate}
        isGenerating={isGenerating}
      />

      {/* Group Select Dialog */}
      <GroupSelectDialog
        open={dialogs.dialogs.groupSelect}
        onOpenChange={(open) => {
          if (!open) dialogs.close("groupSelect");
        }}
        tripId={tripId}
        currentGroupId={trip.groupId}
      />

      {/* Quick Expense Dialog */}
      {trip.groupId && (
        <QuickExpenseDialog
          open={dialogs.dialogs.quickExpense}
          onOpenChange={(open) => {
            if (!open) dialogs.close("quickExpense");
          }}
          groupId={trip.groupId}
        />
      )}
    </>
  );
}
